import axios from '../clients/rdn';

// FIXME
export const getUserBookList = (accessKey: string, cmsid: string) =>
  axios.get(`/v3/user/book/${cmsid}`, {
    headers: {
      accessKey,
    },
  });
